var path = 'components/widgets-bundle-select.tpl.html';
var html = " <md-select ng-required=tbRequired ng-model=widgetsBundle md-container-class=tb-widgets-bundle-select placeholder=\"{{ 'widget.select-widgets-bundle' | translate }}\" class=md-no-underline> <md-option ng-repeat=\"item in widgetsBundles\" ng-value=item> <div class=tb-bundle-item> <span>{{item.title}}</span> <span translate class=tb-bundle-system ng-if=isSystem(item)>widgets-bundle.system</span> </div> </md-option> </md-select> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/widgets-bundle-select.tpl.html
// module id = 1422
// module chunks = 1